/**
 * TODO: Change WspFlowURL & EmailingAPIUrl
 */
export const environment = {
    production: true,
    hmr: false,
    ApiUrl: "https://api-campaign.sendo.cloud/",
    WspFlowURL: "https://api-orange.lenore.app/",
    EmailingAPIUrl: "https://api-campaign.sendo.cloud/",
    apiKey: "fQbUHC3LPDQxUve1xi63KBRkImwePfwz",
    accessTokenLocalStorageKey: "access_token",
    domain: "campaign.sendo.cloud",
    ENCRYPTION_KEY: "hPMZoQkj45wNMlBbWVRO675uJTNHjiBo",
    INITIAL_VECTOR: "dcceb891cf8b21350a70810b371fb28c",
};
